import React, { Fragment, useState } from "react"
import { Form } from "react-bootstrap"
import { FaTimes } from "react-icons/fa"
import clsx from "clsx"

import { getMoment } from "utils"
import DatePicker from "./DatePicker"
import classes from "./DatePickerWithInput.module.scss"

const moment = getMoment()

const DatePickerWithInput = props => {
  const {
    type = "datePicker",
    isClearable = false,
    error,
    label,
    disabled = false,
    minDate,
    maxDate,
    className,
    placeholder,
    range = [],
    value,
    onChange = () => { },
    onBlur
  } = props

  const [openDatePicker, setOpenDatePicker] = useState(false)

  const handleClear = e => {
    e.stopPropagation()

    const isRange =
      type === "rangeTimePicker" ||
      type === "rangeDatePicker"

    if (isRange) return onChange([])

    onChange("")
  }

  const getInputValue = () => {
    if (type === "datePicker" && !!value) {
      return moment(value).format("jYYYY/jMM/jDD")
    }

    if (type === "dateAndTimePicker" && !!value) {
      return moment(value).format("jYYYY/jMM/jDD - HH:mm")
    }

    if (type === "timePicker" && !!value) {
      return moment(`1970-01-01 ${value}`).format("HH:mm")
    }

    if (type === "rangeTimePicker" && !!range[0]) {
      return `${moment(`1970-01-01 ${range[1]}`).format("HH:mm")} ~ ${moment(`1970-01-01 ${range[0]}`).format("HH:mm")}`
    }

    if (type === "rangeDatePicker" && range.length > 0) {
      return `${moment(range[1]).format("jYYYY/jMM/jDD")} ~ ${moment(range[0]).format("jYYYY/jMM/jDD")}`
    }

    return ""
  }

  const inputValue = getInputValue()

  const showClearButton =
    isClearable &&
    !(range.length === 0 && !value)

  return (
    <Fragment>
      <div className={className}>
        {
          !!label &&
          <label className={classes["label"]}>
            {label}
          </label>
        }
        <div className={classes["input-container"]}>
          <Form.Control
            readOnly
            onBlur={onBlur}
            value={inputValue}
            disabled={disabled}
            placeholder={placeholder}
            onClick={() => !disabled && setOpenDatePicker(true)}
            className={clsx(
              classes["input"],
              disabled && classes["disabled"],
              !!error && classes["input-error"]
            )}
          />
          {
            showClearButton &&
            <FaTimes
              onClick={handleClear}
              className={classes["close"]}
            />
          }
        </div>
        {
          !!error &&
          <div className={classes["error"]}>
            {error}
          </div>
        }
      </div>
      <DatePicker
        type={type}
        disabled={disabled}
        minDate={minDate}
        maxDate={maxDate}
        range={range}
        value={value}
        onChange={onChange}
        openDatePicker={openDatePicker}
        setOpenDatePicker={setOpenDatePicker}
      />
    </Fragment>
  )
}

export default DatePickerWithInput